/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { type FC, useEffect, useState } from 'react';

interface VersionResponse {
  code: number;
  data?: {
    version?: string;
  };
}

export const AppVersion: FC = () => {
  const [version, setVersion] = useState('');

  useEffect(() => {
    const controller = new AbortController();

    fetch('/api/version', {
      credentials: 'include',
      signal: controller.signal,
    })
      .then(async response => {
        if (!response.ok) {
          return null;
        }
        return (await response.json()) as VersionResponse;
      })
      .then(response => {
        if (response?.code === 0 && response.data?.version) {
          setVersion(response.data.version);
        }
      })
      .catch(() => undefined);

    return () => controller.abort();
  }, []);

  return (
    <div
      className="h-[16px] px-[8px] text-center text-[10px] leading-[16px] font-normal tabular-nums select-none coz-fg-dim"
      aria-label={version ? `版本 ${version}` : undefined}
      data-testid="layout-app-version"
    >
      {version}
    </div>
  );
};
